import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';

const LOGO_URL = 'https://customer-assets-4nw71qhi.emergentagent.net/job_school-mgmt-72/artifacts/eluovc6p_ChatGPT%20Image%20Sep%2015%2C%202026%2C%2009_07_38%20AM.png';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Academics', path: '/academics' },
  { label: 'Admissions', path: '/admissions' },
  { label: 'Campus Life', path: '/campus-life' },
  { label: 'News & Events', path: '/news-events' },
  { label: 'Contact', path: '/contact' },
];

export default function PublicNav({ insideCard }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <nav className={`flex items-center justify-between px-6 sm:px-8 lg:px-12 py-4 lg:py-5 ${insideCard ? '' : 'sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-100'}`} data-testid="public-nav">
        <Link to="/" className="flex items-center gap-2" data-testid="school-logo-brand">
          <img src={LOGO_URL} alt="Tadam Academy" className="w-9 h-9 lg:w-11 lg:h-11 object-contain" />
          <span className="font-bold text-[#1B2A4A] text-sm lg:text-base tracking-tight">Tadam Academy</span>
        </Link>

        <div className="hidden lg:flex items-center gap-5">
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, '-')}-link`}
              className={`text-sm font-semibold transition-colors ${
                location.pathname === link.path
                  ? 'text-[#1B2A4A] border-b-2 border-[#E8A830] pb-0.5'
                  : 'text-slate-500 hover:text-[#1B2A4A]'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <Link to="/login">
            <Button variant="outline" size="sm" className="rounded-full border-slate-300 text-[#1B2A4A] font-semibold text-xs px-5 h-9 hidden sm:inline-flex" data-testid="portal-login-button">
              Log In
            </Button>
          </Link>
          <Link to="/admissions">
            <Button size="sm" className="rounded-full bg-[#E8A830] hover:bg-[#D4982A] text-white font-semibold text-xs px-5 h-9 hidden sm:inline-flex" data-testid="nav-get-started-btn">
              Get Started
            </Button>
          </Link>
          <button className="lg:hidden p-2" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle">
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden border-t border-slate-100 bg-white animate-fade-in px-6 py-4 space-y-1">
          {navLinks.map(link => (
            <Link key={link.path} to={link.path} onClick={() => setMobileOpen(false)}
              className={`block px-4 py-2.5 rounded-lg text-sm font-semibold ${location.pathname === link.path ? 'text-[#E8A830] bg-amber-50' : 'text-slate-600'}`}>
              {link.label}
            </Link>
          ))}
          <div className="pt-3 flex gap-2">
            <Link to="/login" onClick={() => setMobileOpen(false)} className="flex-1">
              <Button variant="outline" className="w-full rounded-full border-slate-300 text-[#1B2A4A]">Log In</Button>
            </Link>
            <Link to="/admissions" onClick={() => setMobileOpen(false)} className="flex-1">
              <Button className="w-full rounded-full bg-[#E8A830] text-white font-bold">Get Started</Button>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
